<template>
  <v-dialog v-model="dialog" persistent width="800px" @keydown.esc="hide">
    <v-form ref="formX" v-model="form_valid">
      <v-card>
        <v-card-title class="card-panel blue lighten-3">Добавление бренда</v-card-title>

        <v-container>
          <v-combobox v-model="form.brandID"
            autofocus
            :items="brandsItems"
            persistent-hint
            hint="Бренд"
            :rules="rules.brandID"
          >
          </v-combobox>
          <v-text-field v-if="form.brandID && typeof form.brandID !== 'object'" v-model.trim="form.brandOwner"
            persistent-hint
            hint="Владелец бренда (необязательно, для агентств)"
          />
        </v-container>

        <v-card-actions>
          <v-btn raised @click="hide">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" raised color="primary" :disabled="!form_valid" :loading="loading" @click.prevent="submitAction">Добавить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import api from '@/api'
import { validationMixin } from 'vuelidate'
import { required, numeric, between } from 'vuelidate/lib/validators'

export default {
  mixins: [ validationMixin ],
  props: [ 'activity', 'brands' ],
  data: () => ({
    dialog: false,
    loading: false,
    form: {},
    form_valid: false,
    rules: {
      brandID: [
        value => !!value || 'Выберите бренд из списка или введите новый',
      ]
    }
  }),
  validations: {
    form: {
      brandID: { required },
    }
  },
  computed: {
    brandsItems () { return this.brands.map(cur => ({ value: cur.brandID, text: cur.brandName})) },
    verrBrandID () { return this.$v.form.brandID.$invalid ? 'Выберите бренд из списка или введите новый' : '' }
  },
  methods: {
    new () {
      this.dialog = true
    },
    hide () {
      this.dialog = false
    },
    submitAction() {
//      if ( this.$v.$invalid ) return
      if ( !this.form_valid ) return
      let request = typeof this.form.brandID === 'object' ? { brandID: this.form.brandID.value } : { brandName: this.form.brandID, brandOwner: this.form.brandOwner }
      this.loading = true
      api.post('activities/addBrand/'+this.activity.activityID, request).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return alert(response.data.data)
        this.dialog = false
        this.form = {}
        this.$emit('updated');
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  },
}
</script>

<style>
.v-list-item { min-height: 30px !important }
.v-list-item__content { padding: 7px 0; }
</style>
